import { render, staticRenderFns } from "./pogs-form__item--pregnancy--infant.vue?vue&type=template&id=a94c65ee&scoped=true&"
import script from "./pogs-form__item--pregnancy--infant.vue?vue&type=script&lang=js&"
export * from "./pogs-form__item--pregnancy--infant.vue?vue&type=script&lang=js&"
import style0 from "./pogs-form__item--pregnancy--infant.vue?vue&type=style&index=0&id=a94c65ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94c65ee",
  null
  
)

export default component.exports